<template>
  <v-card class="elevation-7 print-card" :class="{'mobile-card': $vuetify.breakpoint.xsOnly}">
    <v-toolbar class="toolbar2 white--text">
      <v-toolbar-title>Dados da Serventia</v-toolbar-title>
    </v-toolbar>
    <v-divider light></v-divider>
    <v-layout align-start row fill-height class="remove-space-on-print">
      <v-flex xs6 :class="{'pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div>
            <div>Código Selo:</div>
            <div><b :class="$vuetify.breakpoint.name">{{serventia.codigoSelo}}</b></div>
            <div class="espaco-top">Cartório:</div>
            <div><b :class="$vuetify.breakpoint.name">{{serventia.nome}}</b></div>
            <div class="espaco-top">Responsável:</div>
            <div><b :class="$vuetify.breakpoint.name">{{serventia.nomeTitularCartorio}}</b></div>
            <div class="espaco-top">Comarca:</div>
            <div><b :class="$vuetify.breakpoint.name">{{serventia.comarca.descricao}}</b></div>

          </div>
        </v-card-title>
      </v-flex>
      <v-flex xs6 :class="{'pt-0': $vuetify.breakpoint.name === 'sm'}">
        <v-card-title class="fix-margin-print">
          <div>
            <div class="espaco-top">Endereço:</div>
            <div><b :class="$vuetify.breakpoint.name">{{serventia.endereco}}</b></div>
            <div class="espaco-top">Telefone:</div>
            <div><b :class="$vuetify.breakpoint.name">{{serventia.telefone}}</b></div>
            <div class="espaco-top">Bairro:</div>
            <div><b :class="$vuetify.breakpoint.name">{{serventia.bairro}}</b></div>
            <div class="espaco-top">Localidade:</div>
            <div><b :class="$vuetify.breakpoint.name">{{serventia.localidade.nomeLocalidade}}
              ({{serventia.localidade.tipoLocalidade}})</b></div>
          </div>
        </v-card-title>
      </v-flex>

    </v-layout>
  </v-card>
</template>

<script>
  import Serventia from "../../domain/selo/serventia";

  export default {
    name: "DadosServentiaCard",
    props: {
      serventia: {
        type: Serventia,
        required: true
      }
    },
    data: function () {
      return {};
    }
  }
</script>

<style scoped>
  /*.xs12 > .fix-margin-print {*/
  /*margin: 0;*/
  /*padding: 16px;*/
  /*}*/

  /*.fix-margin-print {*/
  /*margin: 0;*/
  /*padding: 0;*/
  /*}*/

  .toolbar2 {
    background: #53597F;
  }

  .espaco-top {
    margin-top: 0.3em;
  }

</style>



// WEBPACK FOOTER //
// src/components/detalhes/DadosServentiaCard.vue